/* global CVP */
/* jshint latedef:false */

// ## MVPDPicker
//
// The Picker - used to select your provider and start the login process.

'use strict';

var App = require('./app');
var _ = require('./vendor/underscore');
var machina = require('./vendor/machina');
var _logger = require('./logger');
var Dom = require('./dom');
var Util = require('./util');
var ENV = require('./env');
var MVPDConfig = require('./mvpdconfig');
var RememberedProvider = require('./remembered');
var LoginIframe = require('./loginiframe');
var LoginPopup = require('./loginpopup');
var LoginWindow = require('./loginwindow');


var inited = false;
var pickerId = 'mvpdpicker';
var pickerFrameId = 'mvpdPickerFrame';
var pickerFrameSrc = 'about:blank';
var config = {};
var searchFieldDefaultText = 'Enter your TV Provider';
var mvpdIds = [];
var lastProvider = null;

var mvpdpicker = null;
var mvpdbackdrop = null;
var search = null;
var mvpdsByName = null;


function createDarkPhaseMarkup(data) {
	var placeholder = /\$\{([^${}\r\n]+)\}/g;

	function evaluate(input) {
		return input.replace(placeholder, function (match, key/*, offset, string*/) {
			key = Util.trim(key);  // just in case
			if (_.isObject(data.meta) && key in data.meta) {
				var meta = data.meta[key];
				if (_.isObject(meta) && 'text' in meta) {
					var text = _.isString(meta.text) ? meta.text : key;
					if (meta.type === 'url' && _.isString(meta.url)) {
						return '<a target="_blank" href="' + _.escape(meta.url) + '">' + text + '</a>';
					}
					else {
						return text;
					}
				}
				else {
					return key;
				}
			}
			return key;
		});
	}

	return _.map(data.lines, evaluate).join('<br/>');
}

function isInMvpdList(id) {
	return _.contains(mvpdIds, id);
}

function normalizeEvent(originalEvent) {
	// copy properties, as IE does not keep them for deferred events
	var event = _.extend({}, originalEvent || window.event);

	// provide target
	if (!event.target) {
		event.target = originalEvent.srcElement || document;
	}

	return event;
}

function handleSearchFieldBlur(event) {
	event = normalizeEvent(event);
	var search = event.target;
	if (Util.trim(search.value) === '') {
		search.value = searchFieldDefaultText;
	}
}

function handleSearchFieldFocus(event) {
	event = normalizeEvent(event);
	var search = event.target;
	if (search.value === searchFieldDefaultText) {
		search.value = '';
	}
}


var linkedList = null;
var linkedListParent = null;

function createLinkedList(value, index, list) {
	return ({
		el: value,
		next: index < list.length - 1 ? list[index + 1] : null
	});
}

function appendToList(el) {
	linkedListParent.appendChild(el);
}

function insertInListBefore(el, next) {
	linkedListParent.insertBefore(el, next);
}

var getPickerEl = (function () {
	var pickerEl;

	return function () {
		return pickerEl || document.getElementById(pickerId);
	};
}());

function isInPicker(el) {
	var pickerEl = getPickerEl();

	if (pickerEl) {
		return pickerEl.contains(el);
	}

	return false;
}

// function hasParentNode(el) {
// 	return el.parentNode && el.parentNode.nodeType !== 11;
// }

function isNextPointerVisible(obj) {
	return isInPicker(obj.next);
}

function isElPointerVisible(obj) {
	return isInPicker(obj.el);
}

function showListElement(obj) {
	var index = _.indexOf(linkedList, obj) + 2;

	if (!obj.next) {
		appendToList(obj.el);
	}
	else
	if (isNextPointerVisible(obj)) {
		insertInListBefore(obj.el, obj.next);
	}
	else
	if (index < linkedList.length) {
		var nextVisible = _.find(linkedList.slice(index), isElPointerVisible);
		if (nextVisible) {
			insertInListBefore(obj.el, nextVisible.el);
		}
		else {
			appendToList(obj.el);
		}
	}
	else {
		appendToList(obj.el);
	}
}

function hideListElement(obj) {
	var parent = Dom.parent(obj.el);

	if (!parent) {
		return;
	}

	parent.removeChild(obj.el);
}

function showAllItems() {
	if (!linkedList) {
		return;
	}

	var list = linkedList.slice(0).reverse();
	_.each(list, showListElement);
}

function createSearchRegExp(text) {
	return new RegExp(_.map(text.replace(/\s+/, '').split('', 15), Util.escapeRegExp).join('.*'), 'i');
}

function handleEachTextEntry(event) {
	if (linkedList === null && mvpdsByName && mvpdsByName.length) {
		linkedListParent = Dom.parent(mvpdsByName[0]);
		linkedList = _.map(mvpdsByName, createLinkedList);
	}

	var enteredText = event.target.value;
	// var enteredText = (event.currentTarget || this).value;

	// show all providers if empty or default text
	if (!enteredText || enteredText === searchFieldDefaultText) {
		showAllItems();
		return;
	}

	if (!linkedList || !linkedList.length) {
		return;
	}

	var searchRE = createSearchRegExp(enteredText);

	for (var obj, el, i = 0, endi = linkedList.length; i < endi; i += 1) {
		obj = linkedList[i];
		el = obj.el;
		if (searchRE.test(Dom.text(el))) {
			showListElement(obj);
		} else {
			hideListElement(obj);
		}
	}
}

var handleTextEntry = _.debounce(handleEachTextEntry, 600);

function deferTextEntry(event) {
	handleTextEntry(normalizeEvent(event));
}

function centerPicker() {
	Dom.center(mvpdpicker);
}
var recenterPicker = _.debounce(centerPicker, 250);


function createImage(imageUrl) {
	var image = new Image();
	image.src = imageUrl;
	return image;
}

function preloadLogos(mvpds) {
	return _.map(_.pluck(mvpds, 'pickerImage'), createImage);
}

var stateClassNameMap = {
	'welcome': 'state-welcome',
	'remembered': 'state-remember',
	'findbylogo': 'state-mvpdlogo',
	'findbyname': 'state-mvpdlist',
	'noprovider': 'state-notfound',
	'darkprovider': 'state-dark',
	'signin': 'state-signin',
	'error': 'state-error',
	'success': 'state-success'
};

function onStateChange(obj) {

	var classList = Dom.classList(mvpdpicker);

	_.each(stateClassNameMap, function (value) {
		classList.remove(value);
	});

	classList.add(stateClassNameMap[obj.state]);

}

function determinePickerImage(arrayOrObject) {
	var pickerObj;

	if (_.isObject(arrayOrObject) && arrayOrObject.url) {
		return arrayOrObject.url;
	}

	if (_.isArray(arrayOrObject) && arrayOrObject.length !== 0) {
		if (ENV.supports.retina) {
			pickerObj = _.find(arrayOrObject, function (item) {
				return 'retina' in item && item.retina && 'url' in item;
			});
		}
		if (!pickerObj) {
			pickerObj = _.find(arrayOrObject, function (item) {
				return 'url' in item;
			});
		}
		if (pickerObj) {
			return pickerObj.url;
		}
	}
}

function augmentMVPD(arrayOrObject) {
	function processForPickerImage(item) {
		var pickerImage = determinePickerImage(item.picker);
		if (pickerImage) {
			item.pickerImage = pickerImage;
		}
		return item;
	}

	if (_.isArray(arrayOrObject)) {
		return _.each(arrayOrObject, processForPickerImage);
	}

	if (_.isObject(arrayOrObject) && 'picker' in arrayOrObject) {
		return processForPickerImage(arrayOrObject);
	}

	return arrayOrObject;
}


function sortMvpdsByName(mvpd) {
	return mvpd.displayName.toLowerCase();
}

var pickerMarkup = (
	'<div class="header">' +
		'<div class="help"></div>' +
		'<div class="close"></div>' +
		'<div class="title"><span><%= Strings.title %></span></div>' +
	'</div>' +
	'<div class="steps"></div>' +
	'<div class="slates">' +
		'<div class="slate welcome">' +
			'<div class="message welcomemessage"><%= Strings.welcomemessage %></div>' +
			'<button class="welcomeloginbutton"><span><%= Strings.welcomeloginbutton %></span></button>' +
		'</div>' +
		'<div class="slate remembered">' +
			'<div class="message rememberedmessage"></div>' +
			'<div class="footer rememberedfooter">' +
				'<button class="rememberedcancelbutton"><span><%= Strings.rememberedcancelbutton %></span></button>' +
				'<button class="rememberedokbutton"><span><%= Strings.rememberedokbutton %></span></button>' +
			'</div>' +
		'</div>' +
		'<div class="slate pickbylogo">' +
			'<ul class="mvpdsbylogo">' +
				'<% _.each(primaryMvpds, function (mvpd, index) { %>' +
					'<li data-mvpdid="<%- mvpd.ID %>" title="<%- mvpd.displayName %>"><img class="mvpdlogo" alt="<%- mvpd.displayName %>" src="<%- mvpd.pickerImage %>"></li>' +
				'<% }); %>' +
			'</ul>' +
			'<div class="footer">' +
				'<button class="viewallbutton"><span><%= Strings.viewallbutton %></span></button>' +
			'</div>' +
		'</div>' +
		'<div class="slate findbyname">' +
			'<div class="searchheader">' +
				'<div class="searchfield">' +
					'<input class="mvpdsearch" type="text" value="Search">' +
				'</div>' +
			'</div>' +
			'<div class="searchpane">' +
				'<ul class="mvpdsbyname">' +
					'<% _.each(mvpds, function (mvpd) { %>' +
						'<li data-mvpdid="<%- mvpd.ID %>"><%- mvpd.displayName %></li>' +
					'<% }); %>' +
				'</ul>' +
			'</div>' +
			'<div class="footer searchfooter">' +
				'<% if (canUseLogoView) { %>' +
					'<button class="viewtopbutton"><span><%= Strings.viewtopbutton %></span></button>' +
				'<% } %>' +
				'<button class="dontseebutton"><span><%= Strings.dontseebutton %></span></button>' +
			'</div>' +
		'</div>' +
		'<div class="slate noprovider">' +
			'<div class="message noprovidermessage"><%= Strings.noprovidermessage %></div>' +
			'<button class="okbutton noproviderokbutton"><span><%= Strings.noproviderokbutton %></span></button>' +
		'</div>' +
		'<div class="slate darkprovider">' +
			'<div class="message darkprovidermessage"></div>' +
			'<button class="okbutton darkproviderokbutton"><span><%= Strings.darkproviderokbutton %></span></button>' +
		'</div>' +
		'<div class="slate signin">' +
			'<div class="message signinmessage"><%= Strings.signinmessage %></div>' +
			'<div class="spinnerbox">' +
				'<div class="spinner"></div>' +
			'</div>' +
			'<button class="cancelbutton signincancelbutton"><span><%= Strings.signincancelbutton %></span></button>' +
		'</div>' +
		'<div class="slate error">' +
			'<div class="message errormessage"><%= Strings.errormessage %></div>' +
			'<button class="okbutton errorokbutton"><span><%= Strings.errorokbutton %></span></button>' +
		'</div>' +
		'<div class="slate success">' +
			'<div class="message successmessage"><%= Strings.successmessage %></div>' +
			'<button class="watchnowbutton"><span><%= Strings.watchnowbutton %></span></button>' +
		'</div>' +
	'</div>'
);

var pickerTemplate = _.template(pickerMarkup);


var picker = new machina.Fsm({

	initialState : 'closed',

	_priorPickingState : 'findbylogo',

	initialize : function () {
		_.bindAll(this, 'reactivate', 'deactivate', 'onOpened', 'onClosed');

		this._reactivateTimer = CVP.Utils.Timing.eventually(this.reactivate, 20000);
		this._indeterminateTimer = CVP.Utils.Timing.eventually(restartLogin, 12000);
		this._redundantAuthNCheckTimer = CVP.Utils.Timing.eventually(redundantCheckAuthN, 6000);
	},

	setup : function (AuthManager) {
		if (!AuthManager) {
			throw new Error('AuthManager required!');
		}

		this.authManager = AuthManager;

		this.on('handling', function (data) {
			_logger.debug('[picker:' + this.state + '] handling ' + data.inputType, arguments);
		});
		this.on('handled', function (data) {
			_logger.debug('[picker:' + this.state + '] handled ' + data.inputType, arguments);
		});
		this.on('nohandler', function (data) {
			_logger.debug('[picker:' + this.state + '] nohandler', data.inputType, arguments);
		});
		this.on('transition', function (data) {
			_logger.debug('[picker:' + this.state + '] transition from "' + data.fromState + '" to "' + data.toState + '" via "' + data.action + '"', arguments);
		});
		this.on('invalidstate', function () {
			_logger.debug('[picker:' + this.state + '] invalidstate', arguments);
		});
		this.on('deferred', function () {
			_logger.debug('[picker:' + this.state + '] deferred', arguments);
		});

		LoginIframe.on('opened', this.handleLoginOpen, this);
		LoginIframe.on('closed', this.handleLoginClose, this);

		LoginPopup.on('opened', this.handleLoginOpen, this);
		LoginPopup.on('closed', this.handleLoginClose, this);

		LoginWindow.on('opened', this.handleLoginOpen, this);
		LoginWindow.on('closed', this.handleLoginClose, this);

		this.authManager.on('authNPass', function () {
			picker.handle('authNPass');
		});

		this.authManager.on('authNFail', function () {
			picker.handle('authNFail');
		});

		this.on('opened', this.onOpened);
		this.on('closed', this.onClosed);
		this.on('stateChange', onStateChange);
	},

	handleLoginOpen : function () {
		this.handle('loginOpened');
	},

	handleLoginClose : function () {
		this.handle('loginClosed');
	},

	onOpened : function () {
		_logger.log('MVPDPicker:onOpened');

		if (_.isFunction(config.onRender)) {
			if (config.onRender.length) {
				// continuation-passing, expecting a param, will call function when ready, use for async
				config.onRender.call(mvpdpicker, this.display);
			} else {
				// not expecting a param, won't call a function to continue, so we keep going after callback
				config.onRender.call(mvpdpicker);
				this.display();
			}
		} else {
			this.display();
		}

	},

	onClosed : function () {

		// set HTML/CSS state
		mvpdpicker.className = '';

		// Dom.hide(mvpdpicker);
		// Dom.hide(mvpdbackdrop);
		var mvpdpickerClassList = Dom.classList(mvpdpicker);
		var mvpdbackdropClassList = Dom.classList(mvpdbackdrop);
		mvpdpickerClassList.remove('visible');
		mvpdpickerClassList.add('hidden');
		mvpdbackdropClassList.remove('visible');
		mvpdbackdropClassList.add('hidden');

		Dom.off(window, 'resize', recenterPicker);
		Dom.off(window, 'orientationchange', recenterPicker);

		Dom.off(mvpdpicker, 'click', delegateClickHandler);

		Dom.off(search, 'blur', handleSearchFieldBlur);
		Dom.off(search, 'focus', handleSearchFieldFocus);
		Dom.off(search, 'keydown', deferTextEntry);

	},

	deactivate : function () {
		this.handle('deactivate');
	},

	reactivate : function () {
		this.handle('reactivate');
	},

	isOpen : function () {
		return !this.isDeactivated() && this.state !== 'closed';
	},

	isDeactivated : function () {
		return this.state === 'deactivated';
	},

	create : function (config) {
		_logger.log('MVPDPicker:create');

		if (_.isArray(config.primaryMvpds)) {
			preloadLogos(config.primaryMvpds);
		}

		// init picker
		var mvpdpickerEl = Dom.create('div');
		mvpdpickerEl.id = pickerId;
		mvpdpickerEl.className = 'hidden';

		// init picker iframe backdrop
		var pickerFrameEl = Dom.create('iframe');
		pickerFrameEl.id = pickerFrameId;
		pickerFrameEl.className = 'hidden';
		pickerFrameEl.src = pickerFrameSrc;
		pickerFrameEl.scrolling = 'no';
		pickerFrameEl.frameborder = '0';

		// insert iframe first, so picker is on top without relying on z-index
		Dom.append(pickerFrameEl);
		Dom.append(mvpdpickerEl);

		// set "global" vars
		mvpdpicker = mvpdpickerEl;
		mvpdbackdrop = pickerFrameEl;

		mvpdpicker.innerHTML = pickerTemplate({
			Strings: config.Strings,
			canUseLogoView: config.canUseLogoView,
			primaryMaxCount: config.primaryMaxCount,
			primaryMvpds: config.primaryMvpds,
			mvpds: config.mvpds
		});

		inited = true;
	},

	destroy : function () {
		_logger.log('MVPDPicker:destroy');

		// remove picker
		Dom.remove(mvpdpicker);

		// remove picker iframe backdrop
		Dom.remove(mvpdbackdrop);

		// set "global" vars
		mvpdpicker = null;
		mvpdbackdrop = null;

		inited = false;
	},

	open : function (opts) {
		_logger.log('MVPDPicker:open', opts);

		config = opts;
		mvpdIds = _.pluck(config.mvpds, App.MVPD_ID_KEY);

		var canUseLogoView = config.primaryMvpds && config.primaryMvpds.length >= config.primaryMinCount;

		// bootstrap if necessary
		if (!inited || !Dom.id(pickerId)) {
			var mvpds = _.sortBy(config.mvpds, sortMvpdsByName);
			var primaryMvpds = _.sortBy(config.primaryMvpds, 'primaryOrder').slice(0, config.primaryMaxCount);

			// augment mvpds with pickerImage
			augmentMVPD(primaryMvpds);

			this.create({
				Strings: config.Strings,
				canUseLogoView: canUseLogoView,
				primaryMinCount: config.primaryMinCount,
				primaryMaxCount: config.primaryMaxCount,
				primaryMvpds: primaryMvpds,
				mvpds: mvpds
			});

		}

		if (inited || Dom.id(pickerId)) {
			this.handle('open', {
				hasWelcomeSlate: config.hasWelcomeSlate,
				canUseLogoView: canUseLogoView
			});
		}
		else {
			_logger.error('MVPDPicker:open - failed to render to DOM!');
		}

	},

	display : function () {
		_logger.log('MVPDPicker:display');

		// hook up "global" pointers
		search = Dom.one('.mvpdsearch', mvpdpicker);
		mvpdsByName = Dom.all('.mvpdsbyname li', mvpdpicker);

		Dom.on(window, 'resize', recenterPicker);
		Dom.on(window, 'orientationchange', recenterPicker);

		// Dom.show(mvpdbackdrop);
		// Dom.show(mvpdpicker);
		var mvpdpickerClassList = Dom.classList(mvpdpicker);
		var mvpdbackdropClassList = Dom.classList(mvpdbackdrop);
		mvpdbackdropClassList.remove('hidden');
		mvpdbackdropClassList.add('visible');
		mvpdpickerClassList.remove('hidden');
		mvpdpickerClassList.add('visible');

		centerPicker();

		// delegated click handler
		Dom.on(mvpdpicker, 'click', delegateClickHandler);

		// find by name

		search.value = searchFieldDefaultText;
		showAllItems();

		Dom.on(search, 'blur', handleSearchFieldBlur);
		Dom.on(search, 'focus', handleSearchFieldFocus);
		Dom.on(search, 'keydown', deferTextEntry);

	},

	close : function () {
		_logger.log('MVPDPicker:close');

		this.transition('closed');

	},

	states : {

		'deactivated' : {
			_onEnter : function () {
				this._reactivateTimer.start();
			},

			'reactivate' : 'closed',

			_onExit : function () {
				this._reactivateTimer.stop();
			}
		},

		'closed' : {
			_onEnter : function () {
				if (this.priorState && this.priorState !== 'deactivated') {
					if (this.priorState !== 'success') {
						this.emit('canceled', { state: this.priorState });
					}

					this.emit('closed');
				}
			},
			'deactivate' : 'deactivated',
			'open' : function (obj) {
				this.emit('opened');

				// get last provider used
				lastProvider = RememberedProvider.get();

				if (lastProvider && (!isInMvpdList(lastProvider) || !this.authManager.isValidMvpdId(lastProvider))) {
					// forget provider if not in Picker
					RememberedProvider.forget();
					lastProvider = null;
				}

				if (obj.hasWelcomeSlate) {
					this.transition('welcome');
				}
				else if (lastProvider) {
					// populate 'remembered' slate
					populateRememberedProvider();
					this.transition('remembered');
					// Can't immediately login due to pop-up blockers!
					// var mvpd = this.authManager.getMvpdById(lastProvider);
					// if (mvpd.iFrameRequired) {
					// 	this.authManager.openLogin(lastProvider);
					// }
				}
				else if (obj.canUseLogoView) {
					this.transition('findbylogo');
				}
				else {
					this.transition('findbyname');
				}
			}
		},

		'welcome' : {
			_onEnter : function () {
				this.emit('stateChange', { state: 'welcome' });
			},
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'welcomeLoginClicked' : 'findbylogo'
		},

		'findbylogo' : {
			_onEnter : function () {
				this._priorPickingState = this.state;

				if (this._usedRememberedProvider) {
					RememberedProvider.forget();
					delete this._usedRememberedProvider;
				}

				this.emit('stateChange', { state: 'findbylogo' });
			},
			'darkProviderSelected' : darkProviderSelected,
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'viewAllClicked' : 'findbyname',
			'loginOpened' : 'signin',
			'authNPass' : 'success'
		},

		'findbyname' : {
			_onEnter : function () {
				this._priorPickingState = this.state;

				this.emit('stateChange', { state: 'findbyname' });
			},
			'darkProviderSelected' : darkProviderSelected,
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'viewTopClicked' : 'findbylogo',
			'dontSeeClicked' : 'noprovider',
			'loginOpened' : 'signin',
			'authNPass' : 'success'
		},

		'noprovider' : {
			_onEnter : function () {
				this.emit('stateChange', { state: 'noprovider' });
			},
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'noproviderOkClicked' : transitionToProviderSelection
		},

		'darkprovider' : {
			_onEnter : function () {
				this.emit('stateChange', { state: 'darkprovider' });
			},
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'darkproviderOkClicked' : transitionToProviderSelection
		},

		'remembered' : {
			_onEnter : function () {
				this._usedRememberedProvider = true;

				this.emit('stateChange', { state: 'remembered' });
			},
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'rememberedCancelClicked' : 'findbylogo',
			'rememberedOkClicked' : loginWithRememberedProvider,
			'loginOpened' : 'signin',
			'authNPass' : 'success'
		},

		'signin' : {
			_onEnter : function () {
				this.emit('stateChange', { state: 'signin' });
			},
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'loginClosed' : 'indeterminate',
			'signinCancelClicked' : restartLogin,
			'authNPass' : 'success',
			'authNFail' : 'error'
		},

		'indeterminate' : {
			// awaiting either authN success, failure, or timeout after login closed
			// (worried about breaking things during background-login)
			_onEnter : function () {
				this._indeterminateTimer.start();
				this._redundantAuthNCheckTimer.start();
			},

			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'signinCancelClicked' : restartLogin,
			'authNPass' : 'success',
			'authNFail' : 'error',

			_onExit : function () {
				this._indeterminateTimer.stop();
				this._redundantAuthNCheckTimer.stop();
			}
		},

		'error' : {
			_onEnter : function () {
				this.emit('stateChange', { state: 'error' });
			},
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'errorOkClicked' : restartLogin
		},

		'success' : {
			_onEnter : function () {
				this.emit('stateChange', { state: 'success' });
			},
			'helpClicked' : helpClicked,
			'closeClicked' : closeClicked,
			'authNFail' : 'closed',
			'watchNowClicked' : 'closed'
		}

	}
});


// event handlers

function handleInvalidMvpd(id) {
	if (isInMvpdList(id)) {
		picker.handle('darkProviderSelected', id);
	}
	else {
		picker.transition('noprovider');
	}
}

function handleMvpdClick(/*event*/) {
	/* jshint validthis:true */

	var mvpdId = Dom.attr(this, 'data-mvpdid');

	if (picker.authManager.isValidMvpdId(mvpdId)) {
		picker.authManager.openLogin(mvpdId);
	}
	else {
		handleInvalidMvpd(mvpdId);
	}

	picker.emit('mvpdSelected', {
		mvpdId: mvpdId
	});
}

function helpClicked() {
	picker.emit('helpClicked', { state: picker.state });
}

function closeClicked() {
	picker.emit('closeClicked', { state: picker.state });
	picker.transition('closed');
}

// Return to select-by-logo or select-by-name state, whichever was last used.
function transitionToProviderSelection() {
	picker.transition(picker._priorPickingState);
}

function redundantCheckAuthN() {
	picker.authManager._checkAuthN();
}

function restartLogin() {
	_logger.debug('restarting login');
	// You have elected the way of no provider.  Or changed your mind.
	// Force login window/popup/iframe to close if you're closing the picker.
	picker.authManager.closeLogin();
	transitionToProviderSelection();
	picker.authManager.getAuthentication();
}

function darkProviderFailure(mvpdId) {
	picker.emit('darkProviderSelected', { mvpdId: mvpdId, success: false });
	picker.transition('noprovider');
}

function requestDarkPhaseDataSuccess(el, mvpdId, data) {
	if (mvpdId in data && 'lines' in data[mvpdId]) {
		var darkData = data[mvpdId];
		el.innerHTML = createDarkPhaseMarkup(darkData);
		picker.emit('darkProviderSelected', { mvpdId: mvpdId, success: true });
		picker.transition('darkprovider');
	}
	else {
		_logger.debug('Failed to find dark data for provider "' + mvpdId + '"!');
		darkProviderFailure(mvpdId);
	}
}

function requestDarkPhaseDataFailure(mvpdId) {
	_logger.debug('Failed to obtain dark provider data for provider "' + mvpdId + '"!');
	darkProviderFailure();
}

function darkProviderSelected(mvpdId) {
	var el = Dom.one('#mvpdpicker .darkprovidermessage');

	if (!el) {
		_logger.error('Could not find .darkprovidermessage!');
		darkProviderFailure(mvpdId);
		return;
	}

	var success = _.bind(requestDarkPhaseDataSuccess, picker, el, mvpdId);
	var failure = _.bind(requestDarkPhaseDataFailure, picker, mvpdId);

	MVPDConfig.requestDarkPhaseData().then(success, failure);
}

function populateRememberedProvider() {
	var el = Dom.one('#mvpdpicker .rememberedmessage');

	if (!el) {
		_logger.debug('Failed to find Picker remembered message.');
		return;
	}

	if (!lastProvider) {
		el.innerHTML = '';
	}

	var mvpd = picker.authManager.getMvpdById(lastProvider);
	var name = mvpd.displayName || mvpd.ID;
	var logo = mvpd.pickerImage || null;
	var array = [];

	// array.push('<p>Sign in with the TV Provider you previously used for this site?</p>');
	array.push('<p class="rememberedprovider">' + (logo ? '<img src="' + logo + '" width="' + mvpd.picker[0].width + '" height="' + mvpd.picker[0].height + '" alt="' + name + '">' : name) + '</p>');

	el.innerHTML = array.join('');
}

function loginWithRememberedProvider() {
	picker.authManager.openLogin(lastProvider);
}

function delegateClickHandler(event) {
	event = event || window.event;
	var target = event.target || event.srcElement;

	var classList = Dom.classList(target);
	var targetTag = target.tagName;
	var parentTag = target.parentNode.tagName;

	// buttons -- if inner span is clicked, observe parent's classes
	if (targetTag === 'SPAN' && parentTag === 'BUTTON') {
		classList = Dom.classList(target.parentNode);
	}

	// mvpd logos
	if (targetTag === 'IMG' && classList.contains('mvpdlogo')) {
		return handleMvpdClick.apply(Dom.parent(target), arguments);
	}

	// mvpd names
	if (targetTag === 'LI' && Dom.attr(target, 'data-mvpdid')) {
		return handleMvpdClick.apply(target, arguments);
	}

	// help button
	if (classList.contains('help')) {
		return picker.handle('helpClicked');
	}

	// close button
	if (classList.contains('close')) {
		return picker.handle('closeClicked');
	}

	// welcome - login
	if (classList.contains('welcomeloginbutton')) {
		picker.handle('welcomeLoginClicked');
	}

	// mvpd logos - view all
	if (classList.contains('viewallbutton')) {
		return picker.handle('viewAllClicked');
	}

	// mvpd names - view top
	if (classList.contains('viewtopbutton')) {
		return picker.handle('viewTopClicked');
	}

	// mvpd names - don't see
	if (classList.contains('dontseebutton')) {
		return picker.handle('dontSeeClicked');
	}

	// noprovider - ok
	if (classList.contains('noproviderokbutton')) {
		return picker.handle('noproviderOkClicked');
	}

	// darkprovider - ok
	if (classList.contains('darkproviderokbutton')) {
		return picker.handle('darkproviderOkClicked');
	}

	// remembered - cancel
	if (classList.contains('rememberedcancelbutton')) {
		return picker.handle('rememberedCancelClicked');
	}

	// remembered - ok
	if (classList.contains('rememberedokbutton')) {
		return picker.handle('rememberedOkClicked');
	}

	// signin - cancel
	if (classList.contains('signincancelbutton')) {
		return picker.handle('signinCancelClicked');
	}

	// error - ok
	if (classList.contains('errorokbutton')) {
		return picker.handle('errorOkClicked');
	}

	// success - watch now
	if (classList.contains('watchnowbutton')) {
		return picker.handle('watchNowClicked');
	}
}


module.exports = picker;
